import { useState, useEffect } from 'react';

export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/71bb1da8e03ee9c8bc92e8d7da09997f.jpg"
          alt="Focaccia Restaurant"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Cairo, sans-serif' }}>
            مطعم فوكاتشيا
          </h1>
          <div className="w-32 h-1 bg-gradient-to-r from-teal-400 to-orange-400 mx-auto mb-8"></div>
          <p className="text-xl md:text-2xl text-white/95 mb-4 leading-relaxed">
            تجربة طعام فندقية راقية على مدار اليوم
          </p>
          <p className="text-lg md:text-xl text-white/90 mb-12 leading-relaxed">
            استمتع ببوفيه الفطور المفتوح يوميًا، بالإضافة إلى وجبات الغداء والعشاء الفاخرة
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button
              onClick={() => scrollToSection('menu')}
              className="bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 text-white px-10 py-5 rounded-xl text-lg font-bold transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
            >
              استكشف قوائمنا
            </button>
            <button
              onClick={() => scrollToSection('reservation')}
              className="bg-white/10 backdrop-blur-md hover:bg-white/20 text-white border-2 border-white/50 px-10 py-5 rounded-xl text-lg font-bold transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
            >
              احجز طاولتك
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/80"></i>
      </div>
    </section>
  );
}